import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeRoof: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHomeRoof"><Path d="M22.5459 9.37798L11.9995 1.82764L1.45312 9.37798L2.3263 10.5976L3.99951 9.39975V21H19.9995V9.39973L21.6728 10.5976L22.5459 9.37798Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeRoof;
